import { render } from "./ScoreLabelSection.vue?vue&type=template&id=4524ce2b&scoped=true"
import script from "./ScoreLabelSection.vue?vue&type=script&lang=js"
export * from "./ScoreLabelSection.vue?vue&type=script&lang=js"

import "./ScoreLabelSection.vue?vue&type=style&index=0&id=4524ce2b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4524ce2b"]])

export default __exports__